import { Link } from "react-router-dom";
import { Scale, HeartPulse, Zap, Infinity as InfinityIcon, Sparkles, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

const ICONS = {
  "glp-1-research": Scale,
  "healing-recovery-research": HeartPulse,
  "growth-hormone-research": Zap,
  "cellular-longevity-research": InfinityIcon,
};

export default function CategoryGrid({ categories }) {
  return (
    <section className="relative py-24 bg-section-tint overflow-hidden" data-testid="category-grid-section">
      <div className="absolute inset-0 bg-hex-pattern opacity-50 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-xs tracking-[0.2em] uppercase font-semibold text-brandblue-600">Research Categories</span>
          <h2 className="mt-3 text-3xl sm:text-4xl tracking-tight font-medium text-slate-900 font-display">Explore Our Research Portfolio</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {categories.map((cat, idx) => {
            const Icon = ICONS[cat.slug] || Sparkles;
            return (
              <motion.div
                key={cat.slug}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: idx * 0.05 }}
              >
                <Link
                  to={`/shop?category=${cat.slug}`}
                  className="group block h-full bg-white border border-slate-200 rounded-2xl p-6 card-lift shadow-premium-sm hover:shadow-blue-glow hover:border-blue-200"
                  data-testid={`category-card-${cat.slug}`}
                >
                  <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-blue-900 to-blue-500 flex items-center justify-center mb-5 shadow-blue-glow-sm group-hover:shadow-blue-glow transition-shadow duration-300">
                    <Icon className="h-6 w-6 text-white" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-display font-semibold text-slate-900 text-sm mb-2 group-hover:text-brandblue-700 transition-colors">{cat.name}</h3>
                  <p className="text-xs text-slate-500 leading-relaxed mb-4">{cat.description}</p>
                  <span className="inline-flex items-center text-xs font-semibold text-brandblue-600">
                    Explore <ArrowRight className="h-3 w-3 ml-1 group-hover:translate-x-1 transition-transform" />
                  </span>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
